/**
 * Analytics Constants - Centralized event names and categories
 * Provides type safety and prevents typos in analytics event tracking
 */

export const ANALYTICS_EVENTS = {
  // Game-related events
  GAME: {
    START: 'game_start',
    COMPLETE: 'game_complete',
    DAILY_START: 'daily_challenge_start',
    DAILY_COMPLETE: 'daily_challenge_complete',
    FIRST_COMPLETE: 'first_game_complete'
  },
  
  // User behavior events
  USER: {
    SETTINGS_CHANGE: 'settings_change',
    MODE_SWITCH: 'mode_switch',
    ENGAGEMENT: 'user_engagement',
    RETURN_VISIT: 'return_visit',
    MODAL_OPEN: 'modal_open'
  },
  
  // Sharing events - critical for NPS tracking
  SHARING: {
    CLIPBOARD: 'share_clipboard',
    TWITTER: 'share_twitter', 
    FACEBOOK: 'share_facebook',
    WHATSAPP: 'share_whatsapp'
  },
  
  // Performance and error events
  SYSTEM: {
    PERFORMANCE_ISSUE: 'performance_issue',
    ERROR_ENCOUNTERED: 'error_encountered'
  },
  
  // Conversion and milestone events
  CONVERSION: {
    STREAK_MILESTONE: 'streak_milestone'
  }
} as const;

// Type helper to extract all possible event names
export type AnalyticsEventName = typeof ANALYTICS_EVENTS[keyof typeof ANALYTICS_EVENTS][keyof typeof ANALYTICS_EVENTS[keyof typeof ANALYTICS_EVENTS]];

// Sharing platform types for better type safety
export const SHARING_PLATFORMS_ANALYTICS = {
  CLIPBOARD: 'clipboard',
  TWITTER: 'twitter',
  FACEBOOK: 'facebook',
  WHATSAPP: 'whatsapp'
} as const;

export type SharingPlatform = typeof SHARING_PLATFORMS_ANALYTICS[keyof typeof SHARING_PLATFORMS_ANALYTICS];

// Modal types for tracking
export const MODAL_TYPES = {
  SETTINGS: 'settings',
  HOW_TO_PLAY: 'how_to_play',
  RESULTS: 'results'
} as const;

export type ModalType = typeof MODAL_TYPES[keyof typeof MODAL_TYPES];

// Event categories for organized analytics
export const EVENT_CATEGORIES = {
  GAME: 'game',
  USER_BEHAVIOR: 'user_behavior', 
  SHARING: 'sharing',
  PERFORMANCE: 'performance',
  CONVERSION: 'conversion',
  ERROR: 'error'
} as const;

export type EventCategory = typeof EVENT_CATEGORIES[keyof typeof EVENT_CATEGORIES];